import { useEffect, useState } from 'react';
import { useEventBus } from '../../../../../hooks/use-event-bus';
import { EventIvShowNoInsuranceDialog, EventIvShowVerificationDialog } from '../../../../../types/event-bus';
import InsuranceUnknownStatusDialog from '../../status-dialog/insurance-unknown/insurance-unknown-dialog';
import { PatientIvStatusDialogSelector } from '../../status-dialog/patient-iv-status-dialog-selector';
import { PatientIvContext } from './context';

export const PatientIvProvider = (props: any) => {
  const { listen } = useEventBus();
  const [knownInsuranceEvent, setKnownInsuranceEvent] = useState<EventIvShowVerificationDialog>();
  const [unknownInsuranceEvent, setUnknownInsuranceEvent] = useState<EventIvShowNoInsuranceDialog>();
  const [ivDialogOpened, setIvDialogOpened] = useState(false);

  useEffect(() => {
    const listener1 = listen('ivShowVerificationDialog', (event) => {
      resetAllEvents();
      setKnownInsuranceEvent(event as EventIvShowVerificationDialog);
      setIvDialogOpened(true);
    });

    const listener2 = listen('ivShowNoInsuranceDialog', (event) => {
      resetAllEvents();
      setUnknownInsuranceEvent(event as EventIvShowNoInsuranceDialog);
      setIvDialogOpened(true);
    });

    return () => {
      listener1();
      listener2();
    };
  }, []);

  const handleIvDialogClose = () => {
    setIvDialogOpened(false);
    resetAllEvents();
  };

  const resetAllEvents = () => {
    setKnownInsuranceEvent(undefined);
    setUnknownInsuranceEvent(undefined);
  };

  return (
    <PatientIvContext.Provider value={null!}>
      {props.children}
      {unknownInsuranceEvent && (
        <InsuranceUnknownStatusDialog
          opened={ivDialogOpened}
          onClose={handleIvDialogClose}
          patientFlow={{
            patientId: unknownInsuranceEvent.data.patientId,
            verificationPriority: unknownInsuranceEvent.data.priority,
            patientIvSummary: undefined
          }}
          locationId={unknownInsuranceEvent.data.locationId}
          providerId={unknownInsuranceEvent.data.providerId}
        />
      )}
      {knownInsuranceEvent && (
        <PatientIvStatusDialogSelector
          opened={ivDialogOpened}
          patientInsuranceEvent={knownInsuranceEvent}
          onClose={handleIvDialogClose}
        />
      )}
    </PatientIvContext.Provider>
  );
};
